import React from 'react';
import { Typography, Divider, Card } from 'antd';
import Navbar from './Navbar';
import Footer from '../component/Footer';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
            <Navbar />
            <div style={{ flex: 1, padding: '60px 20px', display: 'flex', justifyContent: 'center' }}>
                <Card 
                    bordered={false} 
                    style={{ 
                        width: '100%', 
                        maxWidth: 1000, 
                        borderRadius: 24, 
                        boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                        padding: '20px 40px' 
                    }}
                >
                    <Title level={1} style={{ color: '#0B1F4D', fontWeight: 800, textAlign: 'center', marginBottom: 10 }}>Privacy Policy</Title>
                    <div style={{ textAlign: 'center', marginBottom: 30 }}>
                        <Text type="secondary" style={{ fontSize: 16 }}>
                            Effective Date: {new Date().toLocaleDateString()}
                        </Text>
                    </div>
                    <Divider style={{ borderColor: '#FF8110', borderWidth: 2, width: '100px', minWidth: '100px', margin: '0 auto 40px auto' }} />
                    
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from Nearzon. We take your privacy seriously and are committed to protecting your personal data.
                    </Paragraph>
                    
                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>1. Personal Information We Collect</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>2. How Do We Use Your Personal Information?</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations). We also use this information to communicate with you, screen our orders for potential risk or fraud, and provide you with information or advertising relating to our products or services.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>3. Sharing Your Personal Information</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        We share your Personal Information with third parties to help us use your Personal Information, as described above. We also use third-party analytics services to help us understand how our customers use the Site. Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>4. Your Rights</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        If you are a resident of certain territories, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or removed. If you would like to exercise this right, please contact us through the contact information below.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>5. Changes to This Policy</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>Contact Us</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at <a href="mailto:support@nearzon.com" style={{ color: '#0B1F4D', fontWeight: 600 }}>support@nearzon.com</a>.
                    </Paragraph>
                </Card>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
